import { ReactNode, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faChevronUp, faChevronDown } from '@fortawesome/pro-regular-svg-icons'
import Typography from '@mui/material/Typography'
import { useStyles } from './SectionCard.styles'

interface SectionCardProps {
  icon: IconDefinition
  title: string
  headerRight?: ReactNode
  collapsible?: boolean
  defaultOpen?: boolean
  children: ReactNode
  testId?: string
}

export const SectionCard = ({
  icon,
  title,
  headerRight,
  collapsible = false,
  defaultOpen = true,
  children,
  testId,
}: SectionCardProps) => {
  const { classes } = useStyles()
  const [open, setOpen] = useState(defaultOpen)

  return (
    <section className={classes.card} data-testid={testId}>
      <div className={classes.header}>
        <div className={classes.titleGroup}>
          <span className={classes.iconBox}>
            <FontAwesomeIcon icon={icon} />
          </span>
          <Typography component="h2" className={classes.title}>
            {title}
          </Typography>
        </div>
        <div className={classes.headerRight}>
          {headerRight}
          {collapsible && (
            <button
              type="button"
              className={classes.chevron}
              onClick={() => setOpen(prev => !prev)}
              aria-label={open ? 'Collapse' : 'Expand'}
            >
              <FontAwesomeIcon icon={open ? faChevronUp : faChevronDown} />
            </button>
          )}
        </div>
      </div>
      {open && <div className={classes.body}>{children}</div>}
    </section>
  )
}
